import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import AppRouter from "./components/AppRouter";
import { AppKitAuthProvider } from "./contexts/AppKitAuthContext";
import { AppKitProvider } from "./providers/AppKitProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppKitProvider>
        <AppKitAuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AppKitAuthProvider>
      </AppKitProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
